/* eslint-disable react/prop-types */
import { Cancel, Check, Delete, Edit, Undo } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import UpdateIcon from "@mui/icons-material/Update";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  darken,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SelectCustomer from "components/SelectCustomer";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import useAuth from "hooks/useAuth";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  API_ROUTES,
  API_ROUTES_V2,
  API_URL,
  PermissionMenuKey,
} from "../../utils/constants";
import TongHopPhieuDiem from "./tongHopPhieuDiem";
import {
  ID_GROUP_CHUTHE,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  ID_GROUP_NUMBER_ONE,
  ID_GROUP_HOIDONG,
} from "../../utils/constants";
import DialogProgress from "components/CircularProgressWithLabel/dialogProgress";
import useAxiosPrivateForm from "../../hooks/useAxiosPrivateForm";
import PrintIcon from "@mui/icons-material/Print";
import PrintPhieuChamDiem from "./printPhieuChamDiem";
import { LinkImage } from "utils";

const ALLVALUE = { ma: "ALL", ten: "Tất cả" };
const dictTrangThai = {
  1: "Đang chấm",
  2: "Đã hoàn thành",
  3: "Chưa đáp ứng",
};
const dictColorTrangThai = {
  1: "success",
  2: "warning",
  3: "error",
};
function PhieuChamDiem() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const navigate = useNavigate();
  const { user } = useAuth();
  const _timeOut = useRef();
  const setAlert = useSetRecoilState(AlertState);

  const [tableData, setTableData] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedUndoRow, setSelectedUndoRow] = useState(null);
  const [selectedRowForward, setselectedRowForward] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [ForwardConfirmationOpen, setForwardConfirmationOpen] = useState(false);
  const [UndoOpen, setUndoOpen] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [optionNhomSanPham, setOptionNhomSanPham] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [paramsState, setParamsState] = useState({
    nam: null,
    nhomsanpham: ALLVALUE.ma,
  });

  //tongHopPhieuDiem
  const axiosForm = useAxiosPrivateForm();
  const [openTongHop, setOpenTongHop] = useState(false);
  const [dataTongHop, setDataTongHop] = useState();
  const [totalValidationErrors, setTotalValidationErrors] = useState({});
  const [checkTotal, setCheckTotal] = useState();
  const [seenTongHop, setSeenTongHop] = useState(false);
  //tongHopPhieuDiem-progress
  const _openDialog = useRef(false);
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const [valueProgress, setValueProgress] = useState(0);

  //print
  const [detailPrint, setDetailPrint] = useState();
  const [openPrint, setOpenPrint] = useState(false);

  useEffect(() => {
    const fetchDataDataNhomSanPham = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomsanpham");
        setOptionNhomSanPham(response.data["data"]);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataDataNhomSanPham();
  }, []);

  //Kiểm tra nhóm người dùng với id Group
  const checkGroupUser = (user, idGroup) => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == idGroup)) {
        check = true;
      }
    }
    return check;
  };
  //kiểm tra đang đăng nhập với nhóm chủ thể = 5
  const isOwner = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CHUTHE);
  }, [user]);

  //kiểm tra đang đăng nhập với nhóm hội đồng = 6
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);

  //Kiểm tra nhóm người dùng là 1
  const isGroupNumberOne = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_ONE);
  }, [user]);

  //kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  //kiểm tra nhóm người dùng là 8
  const isGroupPhuongXa = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);

  const handleDelete = async () => {
    try {
      await axiosPrivateInstance.delete(
        API_ROUTES.CHAMDIEM + "/" + selectedRow.id
      );
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
      // Remove the selected row from the data
      fetchData(paramsState, pagination, user);
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };
  // Chuyển phiếu
  const handelForwardClick = async (row) => {
    setselectedRowForward(row);
    setForwardConfirmationOpen(true);
  };
  const handleCloseForwardConfirmation = () => {
    // Close the delete confirmation dialog
    setForwardConfirmationOpen(false);
  };
  const handleForward = async () => {
    let values = { id: selectedRowForward.id };
    try {
      const response = await axiosPrivateInstance.put(
        API_ROUTES.CAPNHAPCAPQUANLYPHIEUDANGKY,
        {
          ...values,
        }
      );
      if (response?.data?.code == 200) {
        setAlert({
          alert: true,
          message:
            "Chuyển hồ sơ của Sản phẩm:" +
            selectedRowForward.sanpham_ten +
            " thành công!",
          type: "success",
        });
        setselectedRowForward({});
        //   refresh data
        fetchData(paramsState, pagination, user);
      }
    } catch (error) {
      const ms = error.response.data[0];
      setAlert({ alert: true, message: ms, type: "warning" });
    }
    // Close the delete confirmation dialog
    setForwardConfirmationOpen(false);
  };
  // Hoàn trả phiếu
  const handelUndoClick = async (row) => {
    setSelectedUndoRow(row);
    setUndoOpen(true);
  };
  const handleCloseUndo = () => {
    // Close the delete confirmation dialog
    setUndoOpen(false);
  };
  const handleUndo = async () => {
    let values = { id: selectedUndoRow.id };
    try {
      const response = await axiosPrivateInstance.put(
        API_ROUTES.CAPNHAPTRANGTHAITRAPHIEUDANGKY,
        {
          ...values,
        }
      );
      if (response?.data?.code == 200) {
        setAlert({
          alert: true,
          message:
            "Hoàn trả hồ sơ:" +
            selectedUndoRow.phieudangky_noidung +
            " thành công!",
          type: "success",
        });
        setSelectedUndoRow({});
        //   refresh data
        fetchData(paramsState, pagination, user);
      }
    } catch (error) {
      const ms = error.response.data[0];
      setAlert({ alert: true, message: ms, type: "warning" });
    }
    // Close the delete confirmation dialog
    setUndoOpen(false);
  };
  const handleSaveTotal = async (values) => {
    setSeenTongHop(false);
    if (_openDialog.current) {
      _openDialog.current = false;
    }
    //khi post, put data tính progress complete
    const configCircularProgressWithLabel = {
      onUploadProgress: function (progressEvent) {
        !openLoadingDialog &&
          !_openDialog.current &&
          setOpenLoadingDialog(true);
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setValueProgress(percentCompleted);
      },
    };
    const isHasUploadFile = values?.tepdinhkem?.length > 0;
    let config = {};
    if (isHasUploadFile) {
      config = { ...configCircularProgressWithLabel };
    }
    const handleToEditSuccess = () => {
      setAlert({
        alert: true,
        message: "Cập nhật tổng hợp phiếu điểm thành công!",
        type: "success",
      });
      fetchData(paramsState, pagination, user);
      setTotalValidationErrors({});
      setOpenTongHop(false);
    };
    axiosForm
      .put(
        API_ROUTES_V2.HOIDONGCHAMDIEM + "/" + values.id,
        { ...values },
        { ...config }
      )
      .then((response) => {
        if (response?.data) {
          if (isHasUploadFile) {
            setValueProgress(100);
            setTimeout(() => {
              setOpenLoadingDialog(false);
              handleToEditSuccess();
            }, [400]);
          } else {
            handleToEditSuccess();
          }
        }
      })
      .catch((error) => {
        if (isHasUploadFile) {
          _openDialog.current = true;
          setOpenLoadingDialog(false);
        }
        if (error?.response?.data) {
          let validErrors = {};
          let data = error?.response?.data;
          if (Array.isArray(data)) {
            let value = "";
            value = data?.join(";");
            validErrors = { ...validErrors, another: value };
          } else {
            Object.entries(data).forEach(([key, value]) => {
              let val = "";
              if (Array.isArray(value)) {
                value.map((item) => {
                  val += item;
                });
              } else {
                val = value;
              }
              validErrors = { ...validErrors, [key]: val };
            });
          }
          setTotalValidationErrors(validErrors);
        } else {
          setAlert({
            alert: true,
            message: error?.message || "Lỗi! Vui lòng thử lại sau",
            type: "error",
          });
          console.log(error);
        }
      })
      .finally(() => {
        if (isHasUploadFile) {
          _openDialog.current = true;
          setOpenLoadingDialog(false);
        }
      });
  };

  // Lấy toàn bộ dữ liệu
  const fetchData = async (
    { nam, nhomsanpham },
    { pageIndex, pageSize },
    user
  ) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE);
    const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
    const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
    try {
      let body = {
        nam: nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
        nhomsanpham: nhomsanpham == ALLVALUE.ma ? undefined : nhomsanpham,
        maquan: isGroupSeven ? user?.maquan : undefined,
        maphuong: isGroupPhuongXa ? user.maphuong : undefined,
        thanhvien: isGroupHoiDong ? user?.thanhvien : undefined,
        username: isOwner ? user?.username : undefined,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.CHAMDIEM, {
        params: body,
      });
      const data = response.data?.data;
      const checkStatus = {};
      data?.forEach((chamdiem) => {
        if (chamdiem?.id) {
          const listThanhVien = chamdiem?.thanhvien;
          let checkThanhVien = [];
          listThanhVien?.forEach((thanhvien) => {
            if (
              thanhvien?.phieudanhgia?.length == 0 ||
              thanhvien?.phieudanhgia?.[0]?.trangthai != 2
            ) {
              checkThanhVien.push({
                idThanhVien: thanhvien?.id,
                tenThanhVien: thanhvien?.ten,
              });
            }
          });
          checkStatus[chamdiem.id] = checkThanhVien;
        }
      });
      setCheckTotal(checkStatus);
      setRowCount(response.data?.totalRecord);
      setTableData(data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    _timeOut.current && clearTimeout(_timeOut.current);
    _timeOut.current = setTimeout(() => {
      fetchData(paramsState, pagination, user);
    }, [200]);
  }, [paramsState, pagination, user]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: true,
        enableColumnActions: false,
      },
      {
        accessorKey: "phieudangky_noidung",
        header: "Phiếu đăng ký",
        size: 120,
      },
      {
        accessorKey: "sanpham_ten",
        header: "Sản phẩm",
        size: 150,
      },
      // {
      //   accessorKey: "ngay",
      //   header: "Ngày ban hành",
      //   size: 120,
      //   Cell: ({ cell }) => {
      //     const value = cell.getValue();
      //     return value && dayjs(value).isValid()
      //       ? dayjs(value).format("DD/MM/YYYY")
      //       : "";
      //   },
      // },
      // {
      //   accessorKey: "noidung",
      //   header: "Nội dung",
      //   size: 150,
      // },
      {
        accessorKey: "ngaycham",
        header: "Ngày chấm",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value && dayjs(value).isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : "";
        },
      },
      {
        accessorKey: "tongdiem",
        header: "Tổng điểm",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return typeof value == "number"
            ? parseFloat(value).toLocaleString("en-US")
            : value;
        },
        muiTableBodyCellProps: {
          align: "right",
        },
      },
      {
        accessorKey: "hang",
        header: "Hạng",
        size: 80,
      },
      {
        accessorKey: "trangthai",
        header: "Trạng thái",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={dictTrangThai[value]}
                color={dictColorTrangThai[value]}
                variant="gradient"
              />
            </MDBox>
          );
        },
      },
      // {
      //   accessorKey: "thanhvien",
      //   header: "Tổng thành viên",
      //   size: 120,
      //   Cell: ({ cell }) => {
      //     const value = cell.getValue();
      //     const total = value?.length;
      //     return typeof total == "number"
      //       ? parseFloat(total).toLocaleString("en-US")
      //       : total;
      //   },
      //   muiTableBodyCellProps: {
      //     align: "right",
      //   },
      // },
    ],
    []
  );

  const columnsThanhVien = useMemo(() => {
    let result = [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "anhdaidien",
        header: "Ảnh đại diện",
        size: 100,
        Cell: ({ cell }) => {
          const urlLink = cell.getValue()
            ? API_URL + "/media/" + cell.getValue()
            : LinkImage.userDefault;
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <img
                alt="avatar"
                height={48}
                width={48}
                className="object-cover w-12 h-12"
                src={urlLink}
                loading="lazy"
                style={{ borderRadius: "50%" }}
              />
            </Box>
          );
        },
      },
      {
        accessorKey: "ten",
        header: "Tên thành viên",
        size: 150,
      },
      {
        id: "ykiendanhgia",
        accessorFn: (row) =>
          row.phieudanhgia && row.phieudanhgia.length > 0
            ? row.phieudanhgia[0]?.ykiendanhgia
            : "",
        header: "Ý kiến đánh giá",
        size: 150,
        Cell: ({ renderedCellValue, row }) => <div>{renderedCellValue}</div>,
      },
      {
        accessorKey: "tongdiem",
        header: "Tổng điểm",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return typeof value == "number"
            ? parseFloat(value).toLocaleString("en-US")
            : value;
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "phieudanhgia",
        header: "Trạng thái",
        size: 120,
        Cell: ({ cell }) => {
          const phieuDanhGia = cell.getValue();
          let value = 1;
          if (phieuDanhGia && phieuDanhGia.length > 0) {
            value = phieuDanhGia[0]?.trangthai;
          }
          return (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={dictTrangThai[value]}
                color={dictColorTrangThai[value]}
                variant="gradient"
              />
            </MDBox>
          );
        },
      },
    ];
    return result;
  }, []);
  const handelEditClick = (data) => {
    const { idPhieu, thanhvien } = data;
    idPhieu &&
      thanhvien &&
      navigate(
        `/chamdiemcaphuyen/${PermissionMenuKey.chamdiem}/${PermissionMenuKey.chamdiemhoso}?id=${idPhieu}&thanhvien=${thanhvien}`
      );
  };
  //tongHopPhieuDiemOnChange
  const handelTotalClick = async (data) => {
    const { id, trangthai } = data;
    let checkValue = false;
    if (trangthai == 2) {
      checkValue = true;

      setAlert({
        alert: true,
        message: "Phiếu đã được tổng hợp!",
        type: "info",
      });
    }
    if (trangthai == 3) {
      checkValue = true;
      setAlert({
        alert: true,
        message: "Phiếu đã hoàn trả do chưa đáp ứng đủ tiêu chí OCOP hạng 4!",
        type: "info",
      });
    }
    if (checkTotal?.[id] && checkTotal[id].length > 0) {
      checkValue = true;
      setAlert({
        alert: true,
        message: (
          <div>
            Thành viên{" "}
            <span className="text-red-500 font-semibold">
              {checkTotal?.[id]?.map((item) => item?.tenThanhVien).join(", ")}
            </span>{" "}
            chưa chấm xong. Vui lòng chấm trước khi tổng hợp phiếu điểm!
          </div>
        ),
        type: "warning",
      });
    }
    setSeenTongHop(checkValue);
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.HOIDONGCHAMDIEM + "/" + id
      );
      const data = response.data;
      const dataNewDefault = {
        ...data,
        trangthai_ten: dictTrangThai[data?.trangthai],
        tongdiem: String(data?.tongdiem),
      };
      let dataNew = { ...dataNewDefault };
      if (checkValue) {
        dataNew = {
          ...dataNewDefault,
          ngaycham: dayjs(data?.ngaycham)?.isValid()
            ? dayjs(data?.ngaycham).format("DD/MM/YYYY")
            : data?.ngaycham,
          ngay: dayjs(data?.ngay)?.isValid()
            ? dayjs(data?.ngay).format("DD/MM/YYYY")
            : data?.ngay,
        };
      }
      setDataTongHop(dataNew);
    } catch (error) {
      console.log(error);
      return;
    }
    setOpenTongHop(true);
  };
  const handleToCloseTotal = () => {
    setOpenTongHop(false);
    setDataTongHop(null);
    setSeenTongHop(false);
  };
  //onChangeFilter
  //nam
  const handleChangeDate = (value) => {
    setParamsState((prev) => {
      return {
        ...prev,
        nam: value,
      };
    });
  };
  const handleToClearDate = () => {
    setParamsState((prev) => ({
      ...prev,
      nam: null,
    }));
  };
  //nhomsanpham
  const handleChangeNhomSanPham = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      nhomsanpham: value,
    }));
  };

  //thao tác table con
  const handleClickDetail = (data) => {
    const { id, thanhvien } = data;
    if (id && thanhvien) {
      id &&
        navigate(
          `/chamdiemcaphuyen/${PermissionMenuKey.chamdiem}/${PermissionMenuKey.chiTietChamDiem}?id=${id}&thanhvien=${thanhvien}`
        );
    }
  };

  //print
  const handleToClosePrint = () => {
    setOpenPrint(false);
    setDetailPrint(null);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={4} lg={4}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={paramsState?.nam ? dayjs(paramsState.nam) : null}
                views={["year"]}
                onChange={handleChangeDate}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    placeholder: "---Chọn năm---",
                    fullWidth: true,
                    inputProps: {
                      readOnly: true,
                    },
                  },
                  field: {
                    clearable: true,
                    onClear: handleToClearDate,
                  },
                }}
                label="Năm"
                sx={{
                  ".MuiInputLabel-shrink": {
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <SelectCustomer
              keyValue="nhomsanpham"
              label="Nhóm sản phẩm"
              labelName="ten"
              option={optionNhomSanPham}
              onChange={handleChangeNhomSanPham}
              state={paramsState.nhomsanpham}
              unicode="id"
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableEditing={isHoiDong ? false : true}
          enableFilters={true}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              size: 70,
            },
          }}
          initialState={{
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          state={{
            pagination,
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex" }}>
              {isGroupNumberOne || isGroupNumberSeven ? (
                <Tooltip arrow placement="left" title="Tổng hợp phiếu điểm">
                  <IconButton
                    color="info"
                    onClick={() =>
                      handelTotalClick({
                        id: row.original.id,
                        trangthai: row.original.trangthai,
                      })
                    }
                  >
                    <UpdateIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <></>
              )}
              {isGroupNumberSeven &&
              row.original.hang < 4 &&
              row.original.trangthai == 2 ? (
                <Tooltip
                  arrow
                  placement="left"
                  title="Chuyển trả hồ sơ, chưa đáp ứng tiêu chí"
                >
                  <IconButton
                    // disabled={row.original.trangthaiphieu == 1}
                    color="primary"
                    onClick={() => {
                      let _data = [];
                      _data["id"] = row.original.id;
                      _data["phieudangky_noidung"] =
                        row.original.phieudangky_noidung;
                      handelUndoClick(_data);
                    }}
                  >
                    <Undo />
                  </IconButton>
                </Tooltip>
              ) : (
                <></>
              )}
              {isGroupNumberSeven &&
              row.original.hang >= 4 &&
              row.original.trangthai == 2 ? (
                <Tooltip
                  arrow
                  placement="left"
                  title="Chuyển hồ sơ lên hội đồng cấp tỉnh"
                >
                  <IconButton
                    disabled={row.original.trangthaiphieu == 1}
                    color="primary"
                    onClick={() => {
                      let _data = [];
                      _data["id"] = row.original.id;
                      _data["sanpham_ten"] = row.original.sanpham_ten;
                      handelForwardClick(_data);
                    }}
                  >
                    <SwapHorizontalCircleIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <></>
              )}
            </Box>
          )}
          renderDetailPanel={({ row, table }) => {
            const dataItem = row.original;
            const list = dataItem?.thanhvien;
            return list?.length > 0 ? (
              <MaterialReactTable
                key={
                  "danhsachthanhvien_" +
                  String(row?.original?.id) +
                  "_" +
                  String(row?.original?.hoidong_id)
                }
                muiToolbarAlertBannerProps={
                  isError
                    ? {
                        color: "error",
                        children: "Lỗi khi lấy dữ liệu",
                      }
                    : undefined
                }
                enableEditing
                columns={columnsThanhVien}
                data={list}
                enableFilters={true}
                enableHiding={false}
                enableColumnOrdering={false}
                enableDensityToggle={true}
                enableColumnResizing
                localization={MRT_Localization_VI}
                positionActionsColumn="last"
                initialState={{
                  isLoading: true,
                  columnVisibility: {
                    id: false,
                  },
                  pagination: { pageIndex: 0, pageSize: 5 },
                  density: "compact",
                }}
                state={{
                  isLoading,
                  showAlertBanner: isError,
                  showProgressBars: isRefetching,
                }}
                displayColumnDefOptions={{
                  "mrt-row-actions": {
                    size: isOwner ? 80 : 130,
                  },
                }}
                renderRowActions={({ row, table }) => (
                  <Box sx={{ display: "flex" }}>
                    <Tooltip arrow placement="left" title="Chi tiết">
                      <IconButton
                        color="success"
                        onClick={() => {
                          const phieudangky_id = dataItem?.phieudangky_id;
                          const thanhvien = row.original?.id;
                          handleClickDetail({
                            id: phieudangky_id,
                            thanhvien: thanhvien,
                          });
                        }}
                      >
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                    {row.original?.phieudanhgia?.[0]?.trangthai == 2 && (
                      <Tooltip arrow placement="left" title="In">
                        <IconButton
                          color="error"
                          onClick={() => {
                            const phieudangky_id = dataItem?.phieudangky_id;
                            const thanhvien = row.original?.id;
                            const ten = row.original?.ten;
                            setOpenPrint(true);
                            setDetailPrint({
                              id: phieudangky_id,
                              thanhvien: thanhvien,
                              tenThanhvien: ten,
                            });
                          }}
                        >
                          <PrintIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    {row.original?.phieudanhgia?.[0]?.trangthai == 2 ||
                    isOwner ||
                    checkTotal?.[dataItem?.id]?.length == 0 ? (
                      <></>
                    ) : (
                      (isGroupNumberOne || isGroupNumberSeven || isHoiDong) && (
                        <>
                          <Tooltip arrow placement="left" title="Chỉnh sửa">
                            <IconButton
                              color="info"
                              onClick={() => {
                                let _data = [];
                                _data["idPhieu"] = dataItem?.phieudangky_id;
                                _data["thanhvien"] = row.getValue("id");
                                _data["index"] = row.index;
                                handelEditClick(_data);
                              }}
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                          <Tooltip arrow placement="right" title="Xoá">
                            <IconButton
                              color="primary"
                              onClick={() => {
                                let _data = [];
                                const phieuDanhGia =
                                  row.getValue("phieudanhgia");
                                if (phieuDanhGia && phieuDanhGia?.length > 0) {
                                  _data["idPhieu"] = dataItem?.id;
                                  _data["id"] = phieuDanhGia[0]?.id;
                                  _data["ten"] = row.getValue("ten");
                                  handleOpenDeleteConfirmation(_data);
                                } else {
                                  setAlert({
                                    alert: true,
                                    message:
                                      "Thành viên chưa thực hiện phiếu đánh giá!",
                                    type: "warning",
                                  });
                                }
                              }}
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        </>
                      )
                    )}
                  </Box>
                )}
                muiTablePaperProps={{
                  elevation: 0,
                  sx: {
                    borderRadius: "0",
                    border: "1px solid rgb(211 225 245)",
                    backgroundColor: "#fff",
                  },
                }}
                muiTableBodyProps={{
                  sx: (theme) => ({
                    "& tr:nth-of-type(odd)": {
                      backgroundColor: darken(
                        theme.palette.background.default,
                        0.1
                      ),
                    },
                  }),
                }}
                muiTableBodyCellProps={{
                  sx: {
                    whiteSpace: "break-spaces",
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    ".Mui-TableHeadCell-Content-Wrapper": {
                      whiteSpace: "break-spaces !important",
                      textAlign: "center",
                    },
                  },
                }}
              />
            ) : (
              <Box>
                <Typography textAlign={"center"}>
                  Không có thông tin của danh sách thành viên phiếu chấm
                </Typography>
              </Box>
            );
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
        <TongHopPhieuDiem
          data={dataTongHop}
          open={openTongHop}
          validationErrors={totalValidationErrors}
          onClose={handleToCloseTotal}
          onSave={handleSaveTotal}
          seen={seenTongHop}
        />
        <Dialog open={UndoOpen} onClose={handleCloseUndo}>
          <DialogTitle>
            Hoàn trả hồ sơ, do chưa đáp ứng các tiêu chí OCOP
          </DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn hoàn trả hồ sơ: {selectedUndoRow?.phieudangky_noidung}{" "}
              không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseUndo}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleUndo}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={ForwardConfirmationOpen}
          onClose={handleCloseForwardConfirmation}
        >
          <DialogTitle>Chuyển hồ sơ lên Hội đồng cấp tỉnh</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn chuyển hồ sơ của Sản phẩm:{" "}
              {selectedRowForward?.sanpham_ten} lên Hội đồng cấp tỉnh không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <MDButton
              color="primary"
              onClick={handleForward}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseForwardConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Không
            </Button>
          </DialogActions>
        </Dialog>
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá phiếu đánh giá của thành viên: {selectedRow?.ten} này
              không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
      <PrintPhieuChamDiem
        data={detailPrint}
        open={openPrint}
        onClose={handleToClosePrint}
      />
      <DialogProgress open={openLoadingDialog} value={valueProgress} />
      <Footer />
    </DashboardLayout>
  );
}

export default PhieuChamDiem;
